/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Creates a list of mobile navigation items
 */
function mobileMenuDirective() {
    return {
        restrict: 'E',
        scope: {},
        controller: mobileMenuController,
        template: require('./mobileMenuView.html'),
    };
}

mobileMenuController.$inject = [
    '$scope',
    '$timeout',
    'AccountAuthService',
    'AccountService',
    'HeaderService',
    'IndexService',
    'MobileMenuService',
    'NavLinksService',
    'SolarService',
    'UtilService'
];

function mobileMenuController(
    $scope,
    $timeout,
    AccountAuthService,
    AccountService,
    HeaderService,
    IndexService,
    MobileMenuService,
    NavLinksService,
    SolarService,
    UtilService
) {
    $scope.isLoggedInResponse = AccountAuthService.isLoggedInResponse;
    $scope.rebatesEnabled = UtilService.getSiteSetting('active_account_sections', []).indexOf('rebates') > -1;
    $scope.ordersEnabled = AccountService.isAccountSectionActive('orders');
    $scope.solarEnabled = UtilService.isFeatureEnabled('pick_my_solar');
    $scope.trackNavEngagement = MobileMenuService.trackNavEngagement;
    $scope.customLinks = {};
    $scope.accountLinks = [];
    $scope.otherSitesLinks = [];
    $scope.supportLinks = [];
    $scope.legalLinks = [];

    $scope.isEmailVerificationEnabled = UtilService.isFeatureEnabled('email_verification_enabled');
    // If email verification is _not_ enabled, then isEmailVerified should be true
    $scope.isEmailVerified = !$scope.isEmailVerificationEnabled;
    if ($scope.isEmailVerificationEnabled) {
        // Outside of this if statement, isUserEmailVerified() will break the page on reload
        AccountService.isUserEmailVerified().then(function (userEmailVerified) {
            $scope.isEmailVerified = userEmailVerified;
        });
    }

    $scope.goToSolar = function () {
        $timeout(function () {
            $scope.closeMobileNav();
            $scope.trackNavEngagement('solar', 'my-projects');
            SolarService.goToSolar(SolarService.mySolarLocation, null, false);
        }, 10);
    };

    $scope.signIn = function () {
        HeaderService.signIn();
    };

    $scope.logoutUser = function () {
        HeaderService.logoutUser();
    };

    $scope.displayWelcomeModal = function () {
        IndexService.openModal('#modal-welcome');
    };

    AccountAuthService.onEveryAuthChange('updateMobileMenu', function () {
        $scope.isLoggedInResponse = AccountAuthService.isLoggedInResponse;
    });

    $scope.closeMobileNav = MobileMenuService.closeMobileNav;

    $scope.toggleMobileSubNav = function (parentLink) {
        if (parentLink.showSubNav) {
            parentLink.showSubNav = false;
        } else {
            parentLink.showSubNav = true;
        }
    };

    /**
     * Gets custom mobile nav links from the CMS.
     */
    NavLinksService.getCustomMobileNavLinks().then(function (links) {
        if (links !== null) {
            $scope.customLinks = links.navLinks;
        }
    });

    NavLinksService.getOtherSitesLinks().then(function (links) {
        if (links) {
            $scope.otherSitesLinks = links;
        }
    });

    NavLinksService.getSupportLinks().then(function (links) {
        if (links) {
            $scope.supportLinks = links;
        }
    });

    NavLinksService.getLegalLinks().then(function (links) {
        if (links) {
            $scope.legalLinks = links;
        }
    });
}

module.exports = mobileMenuDirective;
